import firebase from "firebase/app"
import "firebase/auth";
import "firebase/database";

import constants from './constants';

import { FirebaseDatabase } from '../account/firebase-database';
import {BaseView} from '../core/view';
import { Modal, ModalTypes } from '../modal/modal';
import { StringUtil } from '../utils/string-util';
import { TrackingUtil } from '../utils/tracking';

let wishlistCount = 0;
const classNavigationHeartActive = 'navigation__wishlist__icon--active';
const classNavigationEmptyWishlistLink = 'navigation__user-action__item--wishlist-link-empty';

const navigationWishListIcon = document.querySelector('.js-navigation-wishlist-counter-heart');
const navigationWishlistCounter = document.querySelector('.js-navigation-wishlist-counter');
const wishlistElement = document.querySelector('.js-wishlist');

const buildLike = (elem) => {
    return {
        productId: elem.data('product-id'),
        productUuid: elem.data('product-uuid'),
        brand: elem.data('product-brand'),
        brandName: StringUtil.stringify(elem.data('product-brand-name')),
        priceFormatted: StringUtil.stringify(elem.data('product-price-formatted')),
        dateCreated: parseInt(Date.now() / 1000, 10),
        productImageUrl: StringUtil.stringify(elem.data('product-image')),
        productName: StringUtil.stringify(elem.data('product-name')),
        hasBackground: elem.data('product-has-background')
    };
};

// TODO: Refactor `adaptButtons` functionality.

const adaptButtons = function (productUuid, likeCreated) {
    const btns = $('[data-product-uuid="' + productUuid + '"]');
    $.each(btns, function (i, val) {
        const btn = $(val);
        const txt = btn.find('b');
        const wishlistProduct = btn.closest('.js-wishlist-product');
        const product = btn.closest('.js-product-preview');
        const icon = btn.find('.js-product-preview__icon-heart');

        // adapt text
        if (likeCreated) {
            btn.addClass('active');
            product.addClass('active');

            if(icon !== undefined) {
                icon.find("use").attr("xlink:href", "#icon-heart-on");
            }

            if (txt !== undefined) {
                txt.html(txt.data('state-active'));
            }
        } else {
            //Remove active class from button
            btn.removeClass('active');
            product.removeClass('active');

            //if we are on the wishlist, remove from the view
            if (wishlistProduct.length > 0) {
                wishlistProduct.remove();
                document.dispatchEvent(new Event(constants.EVENT_ITEM_REMOVED_FROM_WISHLIST_PAGE));
            }

            if(icon !== undefined) {
                icon.find("use").attr("xlink:href", "#icon-heart-off");
            }

            if (txt !== undefined) {
                txt.html(txt.data('state-default'));
            }
        }
    });
};

const handleFirebaseLike = function (user, elem) {
    const likeExists = elem.hasClass('active');
    const productUuid = elem.data('product-uuid');

    const removeLike = () => {
        FirebaseDatabase.deleteLike(user.uid, productUuid);
        updateWishlistCount(-1);
        adaptButtons(productUuid, false);
        //in case it's an inside wishlist like removal and it empties the wishlist, we want to remove the has-items class
        if(wishlistElement && wishlistCount === 0) {
            wishlistElement.classList.remove('has-items');
        }
        TrackingUtil.throwGAEvent('ProductUnliked', 'Firebase', productUuid, false);
    };

    const saveLike = () => {
        const like = buildLike(elem);

        highlightWishlistLink();
        FirebaseDatabase.createLike(user.uid, productUuid, like).then(() => {
            updateWishlistCount(1);
            adaptButtons(productUuid, true);
            TrackingUtil.throwProductLike(productUuid);
            TrackingUtil.throwGAEvent('ProductLiked', 'Firebase', productUuid, false);
        });
    };

    if (likeExists) {
        removeLike();
    } else {
        saveLike();
    }
};

const refreshFirebaseLikes = function (user) {
    const uid = user.uid;
    const userRef = firebase.database().ref(`stylight/likes/${uid}`);
    userRef.once('value')
        .then(function (snapshot) {
            let count = 0;
            snapshot.forEach(function (childSnapshot) {
                //Check if the user's likes are in the current page and mark them as hearted
                let key = childSnapshot.key;
                adaptButtons(key, true);
                count++;
            });
            setWishlistCount(count);
        });
};

const highlightWishlistLink = () => {
    if(navigationWishListIcon !== null) {
        navigationWishListIcon.classList.add(classNavigationHeartActive);
        // This timing is coupled with an `animation` in the Sass code.
        setTimeout(() => {
            navigationWishListIcon.classList.remove(classNavigationHeartActive);
        }, 900)
    }
};

const updateWishlistCount = function (delta) {
    wishlistCount += delta;
    if (navigationWishlistCounter) {
        navigationWishlistCounter.setAttribute('data-wishlist-items', wishlistCount > 0 ? '' + wishlistCount : '0');
        if (wishlistCount > 0) {
            navigationWishlistCounter.classList.remove(classNavigationEmptyWishlistLink);
        } else {
            navigationWishlistCounter.classList.add(classNavigationEmptyWishlistLink);
        }
    }
};

const setWishlistCount = function (count) {
    if (count > 0) {
        wishlistCount = count;
        if(navigationWishlistCounter != null) {
            navigationWishlistCounter.classList.remove(classNavigationEmptyWishlistLink);
            navigationWishlistCounter.setAttribute('data-wishlist-items', '' + wishlistCount);
        }
    }
};

export default BaseView.extend({

    el: 'body',

    events: {
        'click .js-product-preview-wishlist': 'onClickHandleLike'
    },

    onClickHandleLike: function (e) {
        const self = this;
        firebase.auth().onAuthStateChanged((user) => {
            const likeButton = this.$el.find(e.currentTarget);
            if (user) {
                handleFirebaseLike(user, likeButton);
            } else {
                if (!document.querySelector('.js-quickview')) {
                    new Modal().show({type: ModalTypes.REGISTER});
                }
            }
        });

        // This prevents the clickout.
        return false;
    },

    initialize: function () {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) { refreshFirebaseLikes(user); }
        });
    }
});